namespace Matrix.Data {
    export class DataReportColumnListColumns {
        static columnsKey = 'Data.DataReportColumnList';
    }
}
